import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getTeamFeatureFlagArm = {
  name: "getTeamFeatureFlagArm" as const,
  input: z.object({
    teamId: zExt.objectId(),
    flagKey: createEnum(FeatureFlagKey),
  }),
  output: z.object({ value: z.boolean() }),
};
